// A content hash identifies a selection independently of its JPG/JPEG extension or uploader.
export const contentHashFromKey = (key) => key.split('/').pop().replace(/\.[^.]+$/, '').toLowerCase();

export function captureTimestamp(tags = {}) {
    for (const name of ['DateTimeOriginal', 'DateTimeDigitized', 'DateTime']) {
        const value = tags[name];
        const parts = typeof value === 'string' && value.match(/^(\d{4}):(\d{2}):(\d{2}) (\d{2}):(\d{2}):(\d{2})$/);
        if (!parts || Number(parts[1]) === 0) continue;
        const [, y, m, d, h, min, sec] = parts.map(Number);
        const date = new Date(y, m - 1, d, h, min, sec);
        if (date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d && h < 24 && min < 60 && sec < 60) return date.getTime();
    }
    return null;
}

export function uploadMetadata(file, capturedAt, publicCopy, now = Date.now(), generation = crypto.randomUUID()) {
    return {
        'original-name': file.name.replace(/[^\u0020-\u007E]/g, ''),
        'photo-date': String(capturedAt ?? now), // Existing normal readers expect epoch milliseconds.
        'capture-date': capturedAt == null ? '' : new Date(capturedAt).toISOString(),
        'upload-date': new Date(now).toISOString(),
        'upload-generation': generation,
        'public-copy': String(publicCopy),
    };
}

// Idiomas de la galería pública (revopic-gallery: /{idioma}/g/CODIGO). Sin idioma, /g/CODIGO
// redirige al de cada visitante (su elección en la galería o el de su navegador).
export const GALLERY_LOCALES = ['es', 'en', 'fr', 'pt'];

export function publicGalleryUrl(code, locale) {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const localDevelopment = process.env.NODE_ENV === 'development'
        && ['localhost', '127.0.0.1', '[::1]', '::1'].includes(hostname);
    const base = process.env.REACT_APP_GALLERY_URL?.trim() || (localDevelopment ? 'https://localhost:3001' : null);
    const eventCode = code?.trim();
    const prefix = GALLERY_LOCALES.includes(locale) ? `/${locale}` : '';
    return base && eventCode ? `${base.replace(/\/$/, '')}${prefix}/g/${encodeURIComponent(eventCode.toUpperCase())}` : null;
}
